
/**
 * Parameter:
 * Titel: Wird über den Slot eingefügt
 * Untertitel: Wird über den Parameter "subtitle" übergeben
 * inverseStyle (true/false) steuert die Farbe von Titel und Untertitel
 * textSize (sm, xl, 2xl, 3xl) steuert die Schriftgröße. Standard ist 4xl, dafür muss der Parameter leer oder nicht gesetzt sein.
 * tag (p, h1, h2, ...) steuert das HTML-Tag, das für den Titel verwendet wird. Standard ist <p>.
 */

import { defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    subtitle: String,
    subtitleExists: Boolean,
    inverseStyle: String,
    textSize: String,
    tag: {
      type: String,
      default: 'p',
    },
  },
  setup(props) {
    const displaySubtitle = ref(true)
    if (props.subtitleExists === false) {
      displaySubtitle.value = false
    }

    const inverseStyleStatus = ref(false)
    if (props.inverseStyle === 'true') {
      inverseStyleStatus.value = true
    }

    return {
      displaySubtitle,
      inverseStyleStatus,
    }
  },
})
